import React, { useState, useEffect } from 'react';
import { getAttachmentUrl } from '../../api/creditAuditPortalApi';
import * as S from '../../pages/Portal/Management.styles';

/**
 * Modal for previewing and downloading transaction attachments.
 * Shows image preview for image files, download button for all files.
 */
const AttachmentPreviewModal = ({ auditId, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [attachmentData, setAttachmentData] = useState(null);

  useEffect(() => {
    const loadAttachment = async () => {
      if (!auditId) return;

      setLoading(true);
      setError(null);

      try {
        const data = await getAttachmentUrl(auditId);
        setAttachmentData(data);
      } catch (err) {
        console.error('Error loading attachment:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadAttachment();
  }, [auditId]);

  const handleDownload = () => {
    if (attachmentData?.url) {
      window.open(attachmentData.url, '_blank');
    }
  };

  return (
    <S.ModalOverlay>
      <S.Modal style={{ maxWidth: '800px' }}>
        <S.ModalHeader>
          <h3>Attachment Preview</h3>
          <S.CloseButton onClick={onClose}>&times;</S.CloseButton>
        </S.ModalHeader>

        <S.ModalContent style={{ textAlign: 'center', minHeight: '200px' }}>
          {loading ? (
            <div style={{ padding: '60px', color: '#6b7280' }}>
              Loading attachment...
            </div>
          ) : error ? (
            <S.ErrorBanner>
              Error loading attachment: {error}
            </S.ErrorBanner>
          ) : attachmentData ? (
            <div>
              {/* Filename */}
              <div style={{ marginBottom: '16px', fontSize: '14px', color: '#6b7280' }}>
                <strong>File:</strong> {attachmentData.filename}
              </div>

              {/* Image Preview */}
              {attachmentData.isImage ? (
                <div style={{
                  maxHeight: '500px',
                  overflow: 'auto',
                  border: '1px solid #e5e7eb',
                  borderRadius: '8px',
                  padding: '16px',
                  background: '#f9fafb'
                }}>
                  <img
                    src={attachmentData.url}
                    alt={attachmentData.filename}
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                      borderRadius: '4px'
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.style.display = 'none';
                      setError('Failed to load image');
                    }}
                  />
                </div>
              ) : (
                <div style={{
                  padding: '40px',
                  background: '#f9fafb',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb'
                }}>
                  <div style={{ fontSize: '48px', marginBottom: '16px' }}>
                    {attachmentData.filename.endsWith('.pdf') ? (
                      <span style={{ color: '#ef4444' }}>PDF</span>
                    ) : (
                      <span style={{ color: '#6b7280' }}>FILE</span>
                    )}
                  </div>
                  <div style={{ color: '#6b7280' }}>
                    This file type cannot be previewed.
                    <br />
                    Click the download button below to view it.
                  </div>
                </div>
              )}

              {/* Download Button */}
              <div style={{ marginTop: '24px' }}>
                <S.Button color="#F1AF59" onClick={handleDownload}>
                  Download File
                </S.Button>
              </div>
            </div>
          ) : (
            <div style={{ padding: '60px', color: '#6b7280' }}>
              No attachment found
            </div>
          )}
        </S.ModalContent>

        <S.ModalFooter>
          <S.Button color="#6b7280" onClick={onClose}>
            Close
          </S.Button>
        </S.ModalFooter>
      </S.Modal>
    </S.ModalOverlay>
  );
};

export default AttachmentPreviewModal;
